import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { formatEnglishDate } from '../../_helpers/pdfHelpers'

const DeliverySchedules = ({ hardwareData, softwareData, servicesData }) => {
  return (
    <>
      <Text bold size="h5">
        Delivery Schedules
      </Text>

      <Separator weight={5} />

      <Text bold size="h5">
        Hardware
      </Text>
      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Bundle</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Item</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Description</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>QTY</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Shipping Location</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Estimated Delivery Date</Text>
          </TableCol>
        </TableRow>
        {hardwareData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.bundle}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.quantity}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.shippingLocation}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatEnglishDate(item.estimatedDeliveryDate)}</Text>
            </TableCol>
          </TableRow>
        ))}
      </Table>

      <Separator weight={5} />

      <Text bold size="h5">
        Software
      </Text>
      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Bundle</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Item</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Description</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>QTY</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Shipping Location</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Estimated Delivery Date</Text>
          </TableCol>
        </TableRow>
        {softwareData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.bundle}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.quantity}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.shippingLocation}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{formatEnglishDate(item.estimatedDeliveryDate)}</Text>
            </TableCol>
          </TableRow>
        ))}
      </Table>

      <Separator weight={5} />

      <Text bold size="h5">
        Services
      </Text>
      <Table width="100%" fixedLayout useFontBaseColor>
        <TableRow useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
          <TableCol useFontBaseColor>
            <Text bold>Bundle</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>Item</Text>
          </TableCol>
          <TableCol useFontBaseColor colspan="3">
            <Text bold>Description</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold>QTY</Text>
          </TableCol>
        </TableRow>
        {servicesData.map((item, index) => (
          <TableRow useFontBaseColor key={index}>
            <TableCol useFontBaseColor>
              <Text>{item.bundle}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.item}</Text>
            </TableCol>
            <TableCol useFontBaseColor colspan="3">
              <Text>{item.description}</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{item.quantity}</Text>
            </TableCol>
          </TableRow>
        ))}
      </Table>
    </>
  )
}

export default DeliverySchedules
